import { useFormatLocalizedNumber } from '@pba/react-utils';
import { useCallback } from 'react';
import type { FormatPrice } from '../data-card';

export const useFormatPrice = () => {
  const formatLocalizedNumber = useFormatLocalizedNumber();

  return useCallback(
    ({ currency = 'USD', value }: FormatPrice) => {
      const isInteger = Number.isInteger(Number(value.toFixed(2)));

      return formatLocalizedNumber({
        numberFormatProperties: {
          currency,
          maximumFractionDigits: 2,
          minimumFractionDigits: isInteger ? 0 : 2,
          style: 'currency',
        },
        value,
      });
    },
    [formatLocalizedNumber],
  );
};
